module.exports = __webpack_public_path__ + "static/media/home_section_1.a47ff7bc.jpg";